module.exports = __webpack_public_path__ + "static/img/1.cc051b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/1.png
// module id = sg7B
// module chunks = 0